import startCase from "lodash/startCase";

const HIDDEN_CHANGE_FIELDS = new Set(["dateCreated", "dateModified"]);

export const isHiddenEventLogChangeField = (field: string) => {
  if (HIDDEN_CHANGE_FIELDS.has(field)) {
    return true;
  }

  const leafField = field.split(".").at(-1) ?? field;
  return (
    /^(?:id|ids)$/i.test(leafField) ||
    /Ids?$/.test(leafField) ||
    /_ids?$/i.test(leafField)
  );
};

export const formatDiffValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return "—";
  }

  if (Array.isArray(value)) {
    const items = value.map((item) => formatDiffValue(item));
    return items.join(", ");
  }

  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch {
      return "[unserializable]";
    }
  }

  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }

  return "";
};

export const formatDiffFieldLabel = (field: string) =>
  startCase(field.replace(/\./g, " "));
